import * as R from 'ramda'

export const salutation = {
  MR: 'Mr.',
  MS: 'Ms.',
  MRS: 'Mrs.',
  DR: 'Dr.',
  PROF: 'Prof.'
}

export const salutationKeys = R.keys(salutation)

export const salutationValues = R.values(salutation)
